export const abi = [
    {
        constant: false,
        inputs: [],
        name: 'initialize',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'address',
                name: '_tokenAddress',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_governanceAddress',
                type: 'address'
            },
            {
                internalType: 'address',
                name: '_wormholeAddress',
                type: 'address'
            },
            {
                internalType: 'bytes32',
                name: '_recipient',
                type: 'bytes32'
            },
            {
                internalType: 'address[]',
                name: '_antiAbuseOracleAddresses',
                type: 'address[]'
            }
        ],
        name: 'initialize',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'address',
                name: '_governanceAddress',
                type: 'address'
            }
        ],
        name: 'setGovernanceAddress',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'bytes32',
                name: '_recipient',
                type: 'bytes32'
            }
        ],
        name: 'setRecipientAddress',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'address[]',
                name: '_antiAbuseOracleAddresses',
                type: 'address[]'
            }
        ],
        name: 'setAntiAbuseOracleAddresses',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: false,
        inputs: [
            {
                internalType: 'uint256',
                name: 'arbiterFee',
                type: 'uint256'
            },
            {
                internalType: 'uint32',
                name: '_nonce',
                type: 'uint32'
            }
        ],
        name: 'transferToSolana',
        outputs: [],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'token',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'getGovernanceAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'getRecipientAddress',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    },
    {
        constant: true,
        inputs: [],
        name: 'getAntiAbuseOracleAddresses',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    }
];
//# sourceMappingURL=abi.js.map